export type TIndexResult = 0 | 1 | 2
type TOrdemMascara = [number, number, number]

export interface Fator {
  fatorVendedor: number
  fatorGcom: number
  fatorGR: number
}

export interface Mascaras {
  mascaraVendedor: number
  mascaraGcom: number
  mascaraGR: number
}

export class Mascara {
  readonly aplicarMascaraNosFatores = (fatores: Fator, mascarasAPI: Mascaras): Mascaras => {
    const unidadeMascara = (mascara: number): number => {
      const { length } = mascara.toString()
      return Number('1'.padEnd(length, '0'))
    }

    const aplicarMascara = (fator: number, mascara: number): number => {
      return (fator - 1) * unidadeMascara(mascara) + mascara
    }

    return {
      mascaraVendedor: aplicarMascara(fatores.fatorVendedor, mascarasAPI.mascaraVendedor),
      mascaraGcom: aplicarMascara(fatores.fatorGcom, mascarasAPI.mascaraGcom),
      mascaraGR: aplicarMascara(fatores.fatorGR, mascarasAPI.mascaraGR),
    }
  }

  readonly obterIndexValorPresente = (indexGcom: number, indexGR: number): TIndexResult => {
    const indexes: TOrdemMascara = [0, 1, 2]
    return (indexes.find((p) => ![indexGcom, indexGR].includes(p)) ?? 0) as TIndexResult
  }

  readonly formatar = (mascara: number): string => {
    const thresholds = [
      { limit: 10, decimals: 3 },
      { limit: 100, decimals: 2 },
      { limit: 1000, decimals: 1 },
    ]

    const casasDecimais = thresholds.find(({ limit }) => mascara < limit)?.decimals ?? 0
    const separadorMilharRegex = /\B(?=(\d{3})+(?!\d))/g

    return mascara.toFixed(casasDecimais).replace('.', ',').replaceAll(separadorMilharRegex, '.')
  }

  readonly obterIndexGcom = (ordemDaMascaraGcom: number): TIndexResult => {
    const ordens: TOrdemMascara = [3, 4, 5]
    const ordemGcom = ordens.indexOf(ordemDaMascaraGcom)

    return ordemGcom === -1 ? 0 : (ordemGcom as TIndexResult)
  }

  readonly obterIndexGR = (ordemDaMascaraGcom: number, ordemDaMascaraGR: number): TIndexResult => {
    const ordens: TOrdemMascara = [3, 4, 5]
    if (ordemDaMascaraGcom !== ordemDaMascaraGR) {
      return ordens.indexOf(ordemDaMascaraGR) as TIndexResult
    }
    const indexGcom = this.obterIndexGcom(ordemDaMascaraGcom)
    const fallbackValue = ordens[indexGcom - 1] ?? 0
    return ordens.indexOf(ordens[indexGcom + 1] ?? fallbackValue) as TIndexResult
  }
}
